import { forEach, values } from 'lodash'
import { IFormBloque, IModelBloque, IModelPregunta, IModelPreguntaForm } from '../../model/candidato-api'
import { PreguntaForm } from './pregunta-form'

export class BloqueForm implements IFormBloque {
  // pregs: PreguntaForm[] = []
  data: IModelBloque
  pregsList: PreguntaForm[] = []
  pregs = {}
  preguntas = {}
  eliminar: boolean = false
  restaurar: boolean = false

  constructor(data: IFormBloque) {
    this.data = data.data
    this.pregsList = values(data.pregsList)
      .filter((preg) => preg.data.activo)
      .map((p) => new PreguntaForm(p.data).update(p))
  }

  update(response: IFormBloque) {
    // this.data = response
    this.data = response.data
    this.pregsList = values(response.pregsList)
      .filter((preg) => preg.data.activo)
      .map((p) => new PreguntaForm(p.data).update(p))
    this.eliminar = false
    this.restaurar = false

    return this
  }

  nuevaPregunta(preg: IModelPregunta) {
    let _p = new PreguntaForm({ activo: true, visibleEnForm: true } as IModelPreguntaForm)
    _p.desdePregunta(preg)
    this.pregsList.push(_p)
  }

  beforeSave() {
    // para todas las preguntas, preparar el guardado
    forEach(this.pregsList, (p) => p.beforeSave())
  }

  subirPreg(idx: number) {
    if (idx < 1) {
      console.warn('No puedes subir el primero')
      return
    }

    let panterior = this.pregsList[idx - 1]
    let thisp = this.pregsList[idx]

    this.pregsList.splice(idx - 1, 1, thisp)
    this.pregsList.splice(idx, 1, panterior)
  }

  bajarPreg(idx: number) {
    if (idx >= this.pregsList.length - 1) {
      console.warn('No puedes bajar el último')
      return
    }

    let psiguiente = this.pregsList[idx + 1]
    let thisp = this.pregsList[idx]

    this.pregsList.splice(idx + 1, 1, thisp)
    this.pregsList.splice(idx, 1, psiguiente)
  }
}
